import { addURLParameter } from '@common/utils/urlutils';
import ErrorBox from '@components/common/ErrorBox';
import api from '@utils/api';
import React, { useEffect, useState } from 'react';
const ExpressPaymentsButtonPaypal = (props) => {
    var _a;
    const [error, setError] = useState();
    const [enabled, setEnabled] = useState();
    const [loading, setLoading] = useState();
    useEffect(() => {
        if (props.paymentMethods) {
            setEnabled(!!props.paymentMethods.AdyenPaymentMethods.paymentMethods.find((p) => p.type == 'paypal'));
        }
    }, [props.paymentMethods]);
    useEffect(() => {
        setError('');
    }, [props.bag]);
    const startExpress = () => {
        setLoading(true);
        props.onPaymentSelected();
        api.expressCheckoutStart().then((data) => {
            if (data.continueUrl && data.orderID) {
                let newUrl = addURLParameter(data.continueUrl, 'ID', data.orderID);
                window.location.href = addURLParameter(newUrl, 'token', data.orderToken);
                return;
            }
            else {
                data.continueUrl;
            }
            setLoading(false);
            if (data.error) {
                setError(data.errorMessage);
            }
        });
    };
    if (!enabled || !((_a = props === null || props === void 0 ? void 0 : props.adyenConfig) === null || _a === void 0 ? void 0 : _a.paypalExpressEnabled)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", role: "link", "aria-busy": loading, disabled: loading, className: "button button--secondary button--paypal", id: "container-paypal", onClick: startExpress },
            React.createElement("span", { className: "visually-hidden" }, "Paypal")),
        error && React.createElement(ErrorBox, { errors: [error] })));
};
export default ExpressPaymentsButtonPaypal;
